import { userSelector } from 'scripts/redux/actions/user';
import {
  getDefaultAuthenticatedPath,
  isAdvisorAccount,
} from 'scripts/utilities/userAccountHelper';

export const investorPortalRequiredInterceptor = (
  store,
  nextState,
  replaceState,
) => {
  const { user } = userSelector(store.getState());

  if (!user || !isAdvisorAccount(user)) return false;

  replaceState({
    pathname: getDefaultAuthenticatedPath(user),
    state: { nextPathname: nextState.location.pathname },
  });
  return true;
};

export const advisorPortalRequiredInterceptor = (
  store,
  nextState,
  replaceState,
) => {
  const { user } = userSelector(store.getState());

  if (!user || isAdvisorAccount(user)) return false;

  replaceState({
    pathname: getDefaultAuthenticatedPath(user),
    state: { nextPathname: nextState.location.pathname },
  });
  return true;
};
